module.exports = __webpack_public_path__ + "static/media/teapot_02.8ea4348a.png";